
export const CHATBOT_BLOCK_TYPES = {
    TEXT: "text",
    IMAGE: "image",
    VIDEO: "video",
    AUDIO: "audio",
    DOCUMENT: "document",
    LOCATION: "location",
    BUTTONS: "buttons",
    LIST_REPLY: "list_reply",
    API: "api",
    USER_INPUT: "user_input",
    REDIRECT: "redirect",
    SET_ATTRIBUTE: "set_attribute",
    DELAY: "delay",
    TICKET: "ticket",
    WHATSAPP_TEMPLATE: "whatsapp_template",
};  